// extracted by mini-css-extract-plugin
export default {"wrapper":"GreyContainer_wrapper__re4zf","text":"GreyContainer_text__hhZ8+"};